import { baseApi } from '@shared/utils/api/configs/rtkBaseQueryDemo';

import { getAppServices, getMessageSettings, getPublicAppServices, getSystemSettings } from './endpoints';

const systemSettingsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAppServices: getAppServices(builder),
    getMessageSettings: getMessageSettings(builder),
    getPublicAppServices: getPublicAppServices(builder),
    getSystemSettings: getSystemSettings(builder),
  }),
});

export const {
  useGetAppServicesQuery,
  useGetMessageSettingsQuery,
  useGetPublicAppServicesQuery,
  useGetSystemSettingsQuery,
} = systemSettingsApi;
